import React, { useEffect, useState, useTransition, Suspense } from 'react';
import PropTypes from 'prop-types';

export const SuspenseHelper = ({ fallback, children }) => {
    const [isMounted, setMounted] = useState(false);
    const [isPending, startTransition] = useTransition();

    const mountComponent = () => {
        startTransition(() => {
            setMounted(true);
        });
    };

    useEffect(() => {
        if (!isMounted) {
            mountComponent();
        }
    }, [isMounted]);

    return isPending ? (
        fallback
    ) : (
        <Suspense fallback={fallback}>
            {!isMounted ? fallback : children}
        </Suspense>
    );
};

SuspenseHelper.propTypes = {
    fallback: PropTypes.node.isRequired,
    children: PropTypes.node.isRequired
};

export default SuspenseHelper;
